<section class="floating-button" *ngIf="canSeeAssistant">
  <button *ngIf="!showHideOpenAi" type="button" class="btn btn-icon rounded-circle btn-gradient-warning openChat"
    (click)="showHide()" ngbPopover="{{'BELIVPEDIA.MESSAGES.VIEW_BIX' | translate}}" #popoverBix="ngbPopover" container="body"
    triggers="manual" closeDelay="60000" rippleEffect>
    <span class="ficon font-medium-5 feather">
      <img src="https://belivthumbs.blob.core.windows.net/prod/bot.ico" alt="bot avatar" height="36" width="36" />
    </span>
  </button>

  <div class="chat-box" *ngIf="showHideOpenAi">
    <app-chat-content [isFloating]="true" variant="float" (hideChat)="showHide()"></app-chat-content>
  </div>
</section>
